import type { GQL_ID } from '@@partner:types:graphql'
import type { Promocode } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_PROMOCODE_FIELDS } from '@@partner:graphql/shortcuts'

export interface PromocodeInfoInput {
  id?: GQL_ID
  code: string
  is_active: boolean
}

export interface SavePromocode {
  promocode: Promocode
}
export interface SavePromocodeVariables {
  promocodeInfo: PromocodeInfoInput
}

export const GQL_MUTATION_SAVE_PROMOCODE = gql`
  mutation($promocodeInfo: PromocodeInfoInput!) {
    promocode: savePromocode(promocodeInfo: $promocodeInfo) {
      ${SHORTCUT_PROMOCODE_FIELDS}
    }
  }
`

export const useMutateSavePromocode = () =>
  useMutation<SavePromocode, SavePromocodeVariables>(
    GQL_MUTATION_SAVE_PROMOCODE
  )
